var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"theme-default"},[_c('Navbar'),_c('LeftSidebar'),_c('main',{staticClass:"MasterLayout__main"},[_vm._t("default")],2),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }